import { FiCode, FiLayers, FiGlobe, FiTarget } from "react-icons/fi";

export const services = [
  {
    id: "frontend-development",
    icon: <FiCode aria-hidden="true" />,
    title: "Frontend Development",
    description:
      "A website built from the ground up with responsive layouts, thoughtful structure, and a visual direction that fits your brand.",
  },
  {
    id: "react-development",
    icon: <FiLayers aria-hidden="true" />,
    title: "React Development",
    description:
      "A modern React application built with reusable components, clean architecture, and responsive interfaces designed for real-world use.",
  },
  {
    id: "wordpress-websites",
    icon: <FiGlobe aria-hidden="true" />,
    title: "WordPress Websites",
    description:
      "A clean, functional WordPress website built with Elementor, easy to manage, fast to load, and designed around your brand.",
  },
  {
    id: "landing-pages",
    icon: <FiTarget aria-hidden="true" />,
    title: "Landing Pages",
    description:
      "A focused landing page for a product, service, or idea, developed with thoughtful structure, responsive design, and a clear path toward one meaningful action.",
  },
];